import React, { useEffect, useState } from 'react';
import Breadcumb from '../Layouts/Breadcumb';
import { Container, Grid } from '@mui/material';
import { Constants } from '../endPoints';
import axios from 'axios';
import Silverprice from './Silverprice';

export default function Goldprice() {
  const [goldPrices, setGoldPrices] = useState([]);

  useEffect(() => {
    const fetchGoldPrices = async () => {
      try {
        const response = await axios.get(Constants.listGoldPrices);
        if (response.data.status === 1) {
          setGoldPrices(response.data.data);
        } else {
          console.error('Failed to load gold prices');
        }
      } catch (error) {
        console.error('Error fetching gold prices:', error);
      }
    };

    fetchGoldPrices();
  }, []);

  return (
    <>
      <Breadcumb pagetitle="Price" />
      <section className="inner_body">
        <div className="container pagehding">
          <h2 className="main_heading text-center">
            All Karats Per Todays Prices USD (gram)
          </h2>
          <Grid container spacing={1} className="justify-content-center">
            <Grid item lg={7} md={12} sm={12} xs={12}>
              <table className="prices_table bg-white border border-gray-200">
                <thead>
                  <tr>
                    <th>
                      Gold
                    </th>
                    <th>
                      Price Per Gram
                    </th>
                    <th>
                      Market
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {goldPrices.length > 0 ? (
                    goldPrices.map((item) => (
                      <tr key={item.id}>
                        <td>{item.karat.toUpperCase()}</td>
                        <td>${parseFloat(item.price_per_gram).toFixed(2)}</td>
                        <td>{item.market}</td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="3" className="text-center py-4 text-gray-500">
                        No data found
                      </td>
                    </tr>
                  )}
                </tbody>
              </table>
            </Grid>
          </Grid>
        </div>
      </section>
      <Silverprice />
    </>
  );
}
